import { useContext } from 'react'
import { useLocation } from 'react-router'
import { StoresContext } from '@App/contexts'
import RootStore from '@App/stores/root-store'
import { createMatchSuggestion, createSongwriterMatchSuggestion } from '@App/api/routes/rightsholder/matching'

const useSubmitMatch = () => {
    const { rightsholderStore, songwriterStore, userStore } = useContext<RootStore>(StoresContext)

    const location = useLocation()
    const isSongwriterHub = location.pathname.startsWith('/songwriter')

    return async (songCode: string, recordingGroupIds: string[]) => {
        if (isSongwriterHub) {
            await createSongwriterMatchSuggestion(songwriterStore.currentSongwriterId, {
                songCode,
                recordingGroupIds,
                userName: userStore.userInfo.email,
            })
        } else {
            await createMatchSuggestion(rightsholderStore.currentRightsholderId, {
                songCode,
                recordingGroupIds,
                hfaPublisherNumber: rightsholderStore.memberSummary.hfaPublisherNumber,
            })
        }
    }
}

export default useSubmitMatch
